import { z } from 'my-zod'

export const serviceAreaModel = z.object({
  serviceArea: z.string(),
  productLines: z.string().array()
})
export type serviceAreaModel = z.infer<typeof serviceAreaModel>

export const serviceTaskModel = z.object({
  id: z.number(),
  serviceArea: z.string(),
  serviceAction: z.string(),
  productLines: z.string().array()
})
export type serviceTaskModel = z.infer<typeof serviceTaskModel>
